export const LIBRARY_VERSION = '1.2.0';
export const API_VERSION = 1;
export const CHECKPOINT_SCHEMA_VERSION = 1;
export const OPERATION_SCHEMA_VERSION = 1;
export const SUPPORTED_RUNTIMES = ['browser', 'worker', 'node'] as const;